module.exports = {"list":[{"id":"AF","name":"Air France"},{"id":"LH","name":"Lufthansa"},{"id":"EK","name":"Emirates"},{"id":"AA","name":"American Airlines"}],"maxDiffPerc":"10"}


//////////////////
// WEBPACK FOOTER
// ./src/front/fake/configs/vettori.json
// module id = 7WQw
// module chunks = 9